var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 8,
  viewBox: "0 0 14 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.07747 7.51184L0.244141 1.67851L1.42265 0.5L6.66673 5.74408L11.9108 0.5L13.0893 1.67851L7.25598 7.51184C6.93055 7.83728 6.40291 7.83728 6.07747 7.51184Z",
  fill: "#767676"
})));
export { SvgArrowIcon as ReactComponent };
export default __webpack_public_path__ + "assets/814c55ce.svg";